import { FeatureSettings } from '@graphql/gql/graphql';

export type RequiredFeatureSettings = Pick<FeatureSettings, 'id' | 'isEnabled'>;

export default function isFeatureEnabled(features: RequiredFeatureSettings[], featureName: string): boolean {
  const match = features?.find(feat => feat.id === featureName);
  return match?.isEnabled || false;
}
